var superTiny = "5px";
var tiny = "15px";
var small = "20px";
var base = "30px";
var medium = "45px";
var large = "60px";
export default {
    superTiny: superTiny,
    tiny: tiny,
    small: small,
    base: base,
    medium: medium,
    large: large
};
